
export default {
  data () {
    return {
      dataMixinAutoCallFields: [
        {
          label: 'ID',
          key: 'id',
          sortable: false,
          tdClass: 'call-td call-td--grey',
          thClass: 'call-th'
        },
        {
          label: 'Name',
          key: 'name',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th'
        },
        {
          label: 'Project',
          key: 'project_name',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th'
        },
        {
          label: 'Team',
          key: 'team_name',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Status',
          key: 'status',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Type',
          key: 'type',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Period',
          key: 'days',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center'
        },
        {
          label: 'Time',
          key: 'time',
          sortable: false,
          tdClass: 'call-td call-td--no-wrap',
          thClass: 'call-th'
        },
        {
          label: 'Tasks',
          key: 'settings.tasks_count',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Created at',
          key: 'created_at',
          sortable: true,
          tdClass: 'call-td call-td--no-wrap',
          thClass: 'call-th'
        },
        {
          label: 'Created By',
          key: 'created_by_name',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th call-td--no-wrap'
        },
        {
          label: 'Updated at',
          key: 'updated_at',
          tdClass: 'call-td call-td--no-wrap',
          thClass: 'call-th'
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action'
        }
      ],

      dataMixinAutoCallDetalsFields: [
        {
          label: 'Player ID',
          key: 'player_id',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th'
        },
        {
          label: 'Task ID',
          key: 'task_id',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Auto-Call',
          key: 'status',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Result',
          key: 'call_status',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Attempts',
          key: 'attempts',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Call Time',
          key: 'call_created_at',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Call Duration',
          key: 'call_duration',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center'
        },
        {
          label: 'Created At',
          key: 'created_at',
          sortable: true,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action'
        }
      ],

      dataMixinSubAutoCallDetalsFields: [
        {
          label: 'Status',
          key: 'status',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Duration',
          key: 'duration',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Created At',
          key: 'created_at',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        }
      ],

      dataMixinAutoCallReportFields: [
        // {
        //   label: 'ID',
        //   key: 'team_id',
        //   sortable: false,
        //   tdClass: 'call-td call-td--grey',
        //   thClass: 'call-th'
        // },
        {
          label: 'Team / Project',
          key: 'team_name',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th call-tabel--span'
        },
        {
          label: 'Type',
          key: 'run_type',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center call-tabel--span',
          thStyle: { width: '90px' }
        },
        {
          label: 'Gifts',
          subLabel: 'Auto/Manual',
          key: 'bonuses_count',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center call-tabel--span',
          thStyle: { width: '110px' }
        },
        {
          label: 'Tasks',
          key: 'tasks_count',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th call-tabel--right call-tabel--span',
          thStyle: { width: '110px' }
        },
        {
          label: 'Finished',
          key: 'tasks_success_count',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th call-tabel--right call-tabel--span',
          thStyle: { width: '110px' }
        },
        {
          label: 'Cancelled',
          key: 'tasks_cancelled_count',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th call-tabel--right call-tabel--span',
          thStyle: { width: '110px' }
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action',
          thStyle: { width: '50px' }
        }
      ],

      dataMixinAutoCallReportSubFields: [
        {
          label: '',
          key: 'project_name',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th'
        },
        {
          label: '',
          key: 'run_type',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center',
          thStyle: { width: '90px' }
        },
        {
          label: '',
          key: 'bonuses_count',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center',
          thStyle: { width: '110px' }
        },
        {
          label: '',
          key: 'tasks_count',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th ',
          thStyle: { width: '110px' }
        },
        {
          label: '',
          key: 'tasks_success_count',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th',
          thStyle: { width: '110px' }
        },
        {
          label: '',
          key: 'tasks_cancelled_count',
          sortable: false,
          tdClass: 'call-td call-tabel--right',
          thClass: 'call-th',
          thStyle: { width: '110px' }
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action',
          thStyle: { width: '50px' }
        }
      ]
    };
  },
  methods: {
    onHover (item) {
      item.actions = true;
    },
    onUnHover (item) {
      item.actions = false;
    },
    getRunRows (stats = []) {
      return ['auto', 'custom']
        .map((run_type) =>
          stats.find((item) => item.run_type === run_type))
        .filter(Boolean)
        .filter(item => item.tasks_count !== undefined);
    }
  }
};
